import styled from 'styled-components'

export const Container = styled.div`
	.table-container {
		margin-top: 0;
	}

	details {
		margin: 40px 0 10px;
		border-radius: 6px;
		border: solid 1px #bbb;
		border-bottom-width: 3px;
		height: fit-content;
		justify-self: center;

		&:last-child {
			margin-top: 0;
		}

		> div {
			margin: 18px;
			display: flex;
			flex-direction: column;
			grid-gap: 8px 16px;

			> div {
				.table-container {
					margin-top: 0;
				}

				p {
					margin-bottom: 14px;
				}
			}
		}

		&[open] {
			summary {
				background-color: #FFF;
				color: #424242;

				> svg {
					color: #424242;
				}
			}
		}

		summary {
			cursor: pointer;
			padding: 12px 18px;
			display: flex;
			align-items: center;
			font-size: 16px;
			font-weight: 500;
			border-top-left-radius: 4px;
			border-top-right-radius: 4px;

			> svg {
				margin-right: 8px;
			}

			&:hover {
				background-color: #FFF;
				color: #424242;

				svg {
					color: #424242;
				}

				h1 {
					color: #424242;
				}
			}
		}
	}
`
